var $b6e12833733478ab$exports = {};
$b6e12833733478ab$exports = {
    "pending": `in sospeso`
};


export {$b6e12833733478ab$exports as default};
//# sourceMappingURL=it-IT.module.js.map
